module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-398-retro.31cd929f.jpg";